<div class="container-fluid content-padded">
  <div class="row">
    <div class="col-lg-9 col-md-12 col-sm-12 col-xs-12">
      <div class="learn-about-io">
        <h1 class="title" *ngIf="!isLoadingLearnAboutIo">{{res.name}}</h1>
        <span *ngIf="isLoadingLearnAboutIo" class="loading title"></span>
        <div class="content" [innerHtml]="res?.htmlContent | safeHtml"></div>
        <span class="content loading" *ngIf="isLoadingLearnAboutIo"></span>
      </div>
    </div>
    <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12 thumbnails-container">
        <app-thumb-learn-about-io [routerLink]="['/learn-about-io']"></app-thumb-learn-about-io>
        <app-thumb-living-with-cancer></app-thumb-living-with-cancer>
        <app-thumb-join-today></app-thumb-join-today>
    </div>
  </div>
</div>